<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="dash-gis-report-video" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-icon-button matDialogClose (click)="close()">
            <mat-icon svgIcon="close" aria-label="Close"></mat-icon>
        </button>
    </div>
    <video id="css-video" class="video-js vjs-fluid md-padding" controls autoplay preload="auto" data-setup="{}">
        <source [src]="videoSource" type='video/mp4'>
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
        </p>
    </video>
</div>
<!--
<div class="mat-elevation-z4 dash-gis-report-video" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-icon-button (click)="close()">
            <mat-icon svgIcon="close" aria-label="Close"></mat-icon>
        </button>
    </div>
    <video #target id="css-video" class="video-js vjs-fluid" controls autoplay preload="auto" data-setup="{}">
        <source [src]="videoSource" type="video/mp4" />
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
        </p>
    </video>
</div>
-->
